export const TRACKING_CONSENT_ACCEPTED = "accepted";
export const TRACKING_CONSENT_STORAGE_KEY = "amo_tracking_consent";
export const TRACKING_CONSENT_DISMISSED_KEY =
    "amo_tracking_consent_dismissed";

const canUseBrowserStorage = () => typeof window !== "undefined";

export const getTrackingConsent = () => {
    if (!canUseBrowserStorage()) {
        return "";
    }

    try {
        return window.localStorage.getItem(TRACKING_CONSENT_STORAGE_KEY) || "";
    } catch (_) {
        return "";
    }
};

export const hasTrackingConsent = () =>
    getTrackingConsent() === TRACKING_CONSENT_ACCEPTED;

export const setTrackingConsentAccepted = () => {
    if (!canUseBrowserStorage()) {
        return;
    }

    try {
        window.localStorage.setItem(
            TRACKING_CONSENT_STORAGE_KEY,
            TRACKING_CONSENT_ACCEPTED
        );
        window.sessionStorage.removeItem(TRACKING_CONSENT_DISMISSED_KEY);
    } catch (_) {}
};

export const dismissTrackingConsentBanner = () => {
    if (!canUseBrowserStorage()) {
        return;
    }

    try {
        window.sessionStorage.setItem(TRACKING_CONSENT_DISMISSED_KEY, "true");
    } catch (_) {}
};

export const isTrackingConsentBannerDismissed = () => {
    if (!canUseBrowserStorage()) {
        return false;
    }

    try {
        return (
            window.sessionStorage.getItem(TRACKING_CONSENT_DISMISSED_KEY) ===
            "true"
        );
    } catch (_) {
        return false;
    }
};
